export default "/images/framework/Badge_03.c741cae7.svg?c741cae7";